var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-model"},[_c('el-input',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.inputChange($event)}}},[_c('span',{staticClass:"searchicon",attrs:{"slot":_vm.slotSite},slot:_vm.slotSite},[_vm._v(" "+_vm._s(_vm.type)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }